export default __webpack_public_path__ + "static/en-0a28ba14cfd1af7bb0d42f24c660f859.svg";